import React, { useMemo } from 'react';
import { useCampaignStatus } from '@/contexts/CampaignStatusContext';
import './CampaignBanner.css';

const CampaignBanner: React.FC = () => {
  const { campaignStatus, bannerClosed, closeBanner } = useCampaignStatus();

  const endTime = campaignStatus?.['SD2.5-1080P-72off']?.end_time;
  const formattedEndTime = useMemo(() => {
    if (!endTime) return '';
    const parts = new Intl.DateTimeFormat('zh-CN', {
      timeZone: 'Asia/Shanghai',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date(endTime));
    const getPart = (type: string) => parts.find((p) => p.type === type)?.value ?? '';
    return `${getPart('year')}年${getPart('month')}月${getPart('day')}日 ${getPart('hour')}:${getPart('minute')}`;
  }, [endTime]);

  const text = `🎉Seedance 2.5限时活动｜即日起至${formattedEndTime}会员享1080P生成72折`;

  if (bannerClosed) return null;

  return (
    <div className="campaign-banner">
      <div className="campaign-marquee">
        <div className="campaign-marquee-track">
          <span>{text}</span>
          <span>{text}</span>
        </div>
      </div>
      <span className="campaign-banner-close" onClick={closeBanner}>
        ×
      </span>
    </div>
  );
};

export default CampaignBanner;
